import PropTypes from 'prop-types';
// @mui
import { Stack, CardContent, useTheme } from '@mui/material';
import Card from '@mui/material/Card';
import { formStyleMixin } from './Cards';

interface Props {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	sx?: any;
}

export const FormsStack = (props: Props) => {
	return <Stack spacing={3}>{props.children}</Stack>;
};
export const FormCard = (props: Props) => {
	const theme = useTheme();
	return (
		<Card
			sx={{
				...formStyleMixin(theme),
			}}
		>
			<CardContent sx={{ padding: '32px', ...props.sx }}>
				<Stack spacing={{ xs: 2, sm: 5 }}>{props.children}</Stack>
			</CardContent>
		</Card>
	);
};

export const FormInsideCard = (props: Props) => {
	const theme = useTheme();
	return (
		<Card
			sx={{
				borderRadius: '8px',
				boxShadow: 'none!important',
				border: '1px solid #cbdcde',
				[theme.breakpoints.down('sm')]: {
					padding: '8px',
				},
			}}
		>
			<CardContent
				sx={{
					padding: '16px!important',
					boxShadow: 'none!important',
					...props.sx,
				}}
			>
				<Stack
					spacing={5}
					sx={{
						[theme.breakpoints.down('sm')]: {
							padding: '12px',
						},
					}}
				>
					{props.children}
				</Stack>
			</CardContent>
		</Card>
	);
};
